module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "row export-button-container"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('pl-button', {
    staticClass: "export-button",
    nativeOn: {
      "click": function($event) {
        _vm.show_export_data_modal = true
      }
    }
  }, [_vm._v("\n          Export\n        ")])], 1), _vm._v(" "), (_vm.show_export_data_modal) ? _c('ExportEngagementDataModal', {
    attrs: {
      "fileName": _vm.exportable_file_name,
      "getFile": _vm.fetchClassCSVdata,
      "showButtons": Boolean(_vm.getCurrentRT.submissions.length)
    },
    on: {
      "close": function($event) {
        _vm.show_export_data_modal = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "b student-name-row clickable",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('StudentName')
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('span', {
    staticClass: "mh2"
  }, [_vm._v("\n                Student Name\n                "), (!_vm.dataTableCaretAscStudentsNames) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscStudentsNames) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), (_vm.getCurrentRT.enable_annonymous) ? _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ({
        content: _vm.tooltip_text,
        placement: 'top-start',
        classes: ['info'],
      }),
      expression: "{\n                  content: tooltip_text,\n                  placement: 'top-start',\n                  classes: ['info'],\n                }"
    }],
    staticClass: "clickable eye-container",
    on: {
      "click": _vm.revealNames
    }
  }, [(!_vm.reveal_names) ? _c('i', {
    staticClass: "fa fa-eye"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "submission submission-row b",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Submission")]), _vm._v(" "), _c('td', {
    staticClass: "read-row b",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Read")]), _vm._v(" "), _c('td', {
    staticClass: "comments comments-row b",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('td', {
    staticClass: "feedback assessment-row b",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Feedback")])]), _vm._v(" "), _c('tr', {
    staticClass: "b"
  }, [_c('td', {
    staticClass: "submission clickable",
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('Complete')
      }
    }
  }, [_vm._v("\n            Complete?\n            "), (!_vm.dataTableCaretAscComplete) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscComplete) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "submission clickable",
    attrs: {
      "colspan": "1"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('Words')
      }
    }
  }, [_vm._v("\n            Words\n            "), (!_vm.dataTableCaretAscWords) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscWords) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "submission clickable",
    attrs: {
      "colspan": "1"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('SubmissionStar')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star star ml1 mb1 dib v-mid pt1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (!_vm.dataTableCaretAscSubmissionStar) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscSubmissionStar) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "clickable",
    attrs: {
      "colspan": "1"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('PercentageRead')
      }
    }
  }, [_vm._v("\n            %\n            "), (!_vm.dataTableCaretAscPercentageRead) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscPercentageRead) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "comments clickable",
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('CommentsNumber')
      }
    }
  }, [_vm._v("\n            #\n            "), (!_vm.dataTableCaretAscCommentsNumber) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscCommentsNumber) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "comments clickable",
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('Average_lenght')
      }
    }
  }, [_vm._v("\n            Length\n            "), (!_vm.dataTableCaretAscCommentsAverageLenght) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscCommentsAverageLenght) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "feedback clickable",
    attrs: {
      "colspan": "4"
    },
    on: {
      "click": function($event) {
        return _vm.sortByClick('FeedbackComplete')
      }
    }
  }, [_vm._v("\n            Complete?\n            "), (!_vm.dataTableCaretAscFeedbackComplete) ? _c('i', {
    staticClass: "fa fa-caret-up"
  }) : _vm._e(), _vm._v(" "), (_vm.dataTableCaretAscFeedbackComplete) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.dataTableSorted), function(participant, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "student-container"
    }, [(_vm.reveal_names) ? _c('img', {
      staticClass: "avatar-circlex avatar-size ma1",
      attrs: {
        "src": participant.avatar,
        "alt": "avatar"
      }
    }) : _c('img', {
      staticClass: "avatar-circlex avatar-size ma1",
      attrs: {
        "src": participant.anonymous_identity.avatar_url,
        "alt": "avatar"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "student-name-cell",
      attrs: {
        "title": _vm.reveal_names ?
          participant.name :
          participant.anonymous_identity.name
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.reveal_names ?
      participant.name :
      participant.anonymous_identity.name) + "\n                ")])])]), _vm._v(" "), _vm._l((participant.submission), function(value, key) {
      return [(key === 'complete') ? _c('td', {
        key: value + key,
        staticClass: "submission b",
        attrs: {
          "colspan": "2"
        }
      }, [(value === 'yes') ? _c('span', [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": "/static/live_discussion/check_mark-blue.svg",
          "alt": "check-mark"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "link-student-submission",
        on: {
          "click": function($event) {
            return _vm.redirectToStudentFeedback(
              participant.submissionID,
              'comments'
            )
          }
        }
      }, [_vm._v("\n                    (view)\n                  ")])]) : _c('span', {
        staticClass: "empty-assessment"
      }, [_vm._v("-")])]) : _c('td', {
        key: value + key,
        staticClass: "submission b"
      }, [(key === 'star') ? [(value === true) ? _c('span', [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": "/static/live_discussion/check_mark-yellow.svg",
          "alt": "check-mark"
        }
      })]) : _c('span', {
        staticClass: "empty-assessment"
      }, [_vm._v("-")])] : [_vm._v("\n                  " + _vm._s(value) + "\n                ")]], 2)]
    }), _vm._v(" "), _c('td', {
      key: index,
      staticClass: "b"
    }, [_vm._v(_vm._s(participant.read) + "%")]), _vm._v(" "), _vm._l((participant.comments), function(value, index) {
      return [_c('td', {
        key: index,
        staticClass: "comments b",
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v(_vm._s(value))])]
    }), _vm._v(" "), _vm._l((participant.feedback), function(value, index) {
      return [_c('td', {
        key: index,
        staticClass: "feedback b",
        attrs: {
          "colspan": "4"
        }
      }, [(value === 'yes') ? _c('span', [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": "/static/live_discussion/check_mark.svg",
          "alt": "check-mark"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "link-student-feedback",
        on: {
          "click": function($event) {
            return _vm.redirectToStudentFeedback(
              participant.submissionID,
              'assessment'
            )
          }
        }
      }, [_vm._v("\n                    (view)\n                  ")])]) : _c('span', {
        staticClass: "empty-assessment"
      }, [_vm._v("-")])])]
    })], 2)]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-30551f40!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/individualRoundtableSummaryOverlay.vue
// module id = 1230
// module chunks = 61